<template>
	<create-edit-layout v-if="showCreateEditAdminInvoices" element="AdminInvoices" icon="fas fa-receipt" @duplicatecomplete="$emit('duplicatecomplete')">
		<v-col cols="12" xs="12">
			<ValidationProvider ref="tenant_id" vid="tenant_id" :name="$t('incomedeclarations.tenant')" rules="required" v-slot="{ errors, field }">
				<v-autocomplete class="required" v-model="currentAdminInvoices.tenant_id" :label="$t('incomedeclarations.tenant')" :items="$appOptions.autocompleteAdminClients()" :error-messages="errors" item-text="fullname" item-value="id" :menu-props="'closeOnClick, overflowY'"></v-autocomplete>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="4">
			<ValidationProvider ref="invoice_code" vid="invoice_code" :name="$t('invoices.invoice_code')" rules="required|max:100" v-slot="{ errors, field }">
				<v-text-field class="required" :label="$t('invoices.invoice_code')" v-model="currentAdminInvoices.invoice_code" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<date-field vid="date" :name="$t('invoices.date')" rules="date_format" v-model="currentAdminInvoices.date"></date-field>
		</v-col>
		<v-col cols="6" xs="6" sm="2">
			<price-field vid="amount" :name="$t('invoices.total')" rules="" v-model="currentAdminInvoices.total"></price-field>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<date-field vid="payment_date" :name="$t('invoices.payment_date')" rules="date_format" v-model="currentAdminInvoices.payment_date"></date-field>
		</v-col>
	</create-edit-layout>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		currentAdminInvoices: {
			get: function () {
				return this.$store.getters.getCurrentAdminInvoices;
			},
			set: function (value) {
				this.$store.commit("setCurrentAdminInvoices", value);
			},
		},
		showCreateEditAdminInvoices() {
			return this.$store.getters.showCreateEditAdminInvoices;
		},
	},
};
</script>
